import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Respect Do Not Track — ne pas charger Matomo si activé
    if (navigator.doNotTrack === "1" || window.doNotTrack === "1") {
      return
    }

    this.initializeMatomo()
  }

  initializeMatomo() {
    var _paq = window._paq = window._paq || [];
    _paq.push(['setDoNotTrack', true]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);

    (function() {
      var u = "https://uemadagascar.matomo.cloud/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '4']);
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = 'https://cdn.matomo.cloud/uemadagascar.matomo.cloud/matomo.js';
      s.parentNode.insertBefore(g, s);
    })();
  }
}
